<template>
    <div class="recruit">
        <!--<Header/>-->
        <el-container>
            <div class="content">
                <div class="header">
                    <h2>职位搜索</h2>
                    <div style="margin-top: 15px; width: 500px">
                        <el-input placeholder="请输入内容" v-model="search" @focus="handleFocus">
                            <el-button slot="append" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                        </el-input>
                    </div>
                    <el-menu :default-active="activeIndex" class="type-menu" mode="horizontal" @select="handleSelect">
                        <el-menu-item index="全部">全部</el-menu-item>

                        <el-menu-item :index="item.name" v-for="(item,index) in typeList" :key="index">{{item.name}}</el-menu-item>
                    </el-menu>
                </div>

                <div class="job">
                    <div class="table">
                        <el-table
                                :data="tableData"
                                style="width: 100%">
                            <el-table-column
                                    label="专业/职位"
                                    align="left"
                                    header-align="center"
                                    width="390"
                            >
                                <template slot-scope="scope">

                                    <el-badge value="hot" class="item" v-if="scope.row.hot">

                                    <span style="margin-right: 10px">
                                        <router-link :to="{name: 'detail', params: { id: scope.row.guid }}">
                                        {{ scope.row.situation }}
                                        </router-link>
                                    </span>

                                    </el-badge>
                                    <span style="margin-right: 10px" v-if="!scope.row.hot">
                                    <router-link :to="{name: 'detail', params: { id: scope.row.guid }}">
                                    {{ scope.row.situation }}
                                         </router-link>
                                </span>

                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="type"
                                    label="类别"
                                    align="center"
                                    header-align="center"
                                    width="180"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="degree"
                                    label="学位/学历要求"
                                    align="center"
                                    header-align="center"

                            >
                            </el-table-column>
                            <el-table-column
                                    prop="number"
                                    label="人数"
                                    align="center"
                                    header-align="center"
                                    width="100"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="address"
                                    label="工作地点"
                                    align="center"
                                    header-align="center"
                                    width="200"
                            >
                            </el-table-column>
                            <el-table-column
                                    label="发布日期"
                                    align="center"
                                    header-align="center"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.updateTime}}</span>
                                </template>
                            </el-table-column>

                        </el-table>
                        <el-pagination
                                :background="true"
                                layout="prev, pager, next"
                                @current-change="handleCurrentChange"
                                :total="total" :page-size="this.pageSize">
                        </el-pagination>
                    </div>

                </div>
            </div>
        </el-container>

        <Footer/>
    </div>

</template>

<script>
    import Header from '../base/Header'
    import Footer from '../base/Footer'
    import {getMajorList, getRecruitList} from '../api';

    export default {
        name: 'Home',
        props: {},
        components: {Header, Footer},
        data() {
            return {
                search: '',
                activeIndex: '全部',
                tableData: [],
                page:1,
                total:0,
                pageSize:20,
                typeList: []
            }
        },
        methods: {
            queryMajor() {
                getMajorList().then((res) => {
                    const {content} = res;
                    //专业类别按照id升序排列
                    content.sort((a, b) => (a.code - b.code));
                    this.typeList = content;
                })
            },
            handleFocus() {
                this.search = '';
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getTableList();
            },
            handleSelect(key, keyPath) {
                let params = {
                    data: {
                        situation: key === '全部' ? '' : key,
                        enable: 1
                    },
                    orderBy: "addTime",
                    orderType: "asc",
                    pageNum: 1,
                    pageSize: this.pageSize
                };
                getRecruitList(params).then((res) => {
                    const {list,total} = res.content;
                    this.tableData = list;
                    this.total = total;
                });
            },

            handleSearch() {
                let params = {
                    data: {
                        situation: this.search,
                        enable: 1
                    },
                    orderBy: "addTime",
                    orderType: "asc",
                    pageNum: 1,
                    pageSize: this.pageSize
                };
                getRecruitList(params).then((res) => {
                    const {list,total} = res.content;
                    this.tableData = list;
                    this.total = total;
                });
            },

            getTableList() {
                let params = {
                    data: {
                        situation: "",
                        enable: 1
                    },
                    orderBy: "addTime",
                    orderType: "asc",
                    pageNum: this.page,
                    pageSize: this.pageSize
                };
                getRecruitList(params).then((res) => {
                    const {list,total} = res.content;
                    this.tableData = list;
                    this.total = total;
                });
            }
        },

        created() {
            this.queryMajor();
            this.getTableList()
        }
    }
</script>

<style scoped lang="less">
    .recruit{
        min-width: 1280px;
    }

    .content {
        box-sizing: border-box;
        margin: 80px auto 20px;
        width: 1200px;
        background: #FFF;
        padding: 20px 40px;
        min-height: 768px;

        .header {
            h2 {
                font-size: 18px;
                margin-bottom: 20px;
                padding-left: 20px;
                text-align: left;
                border-left: 5px solid #006eab;
            }
            .type-menu {
                margin: 15px 0;
                border-bottom: none;

                .el-menu-item {
                    height: 40px;
                    line-height: 40px;
                    margin-right: 5px;
                    padding: 0 15px;
                    border-bottom: none;
                    &.is-active {
                        border-bottom: 2px solid #006eab;
                    }
                }
            }
        }

        .job {
            .table {
                .item {
                    margin-top: 10px;
                }
                a {
                    color: #606266;
                    text-decoration: none;
                }
            }
            .el-pagination {
                margin-top: 10px;
            }
        }
    }
</style>
